import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Inbox, Search, Calendar, Users, FileX, QrCode, Receipt, Settings, MessageSquare, Bell } from "lucide-react";

const iconMap = {
  default: Inbox,
  search: Search,
  events: Calendar,
  users: Users,
  error: FileX,
  qr: QrCode,
  receipt: Receipt,
  settings: Settings,
  message: MessageSquare,
  notification: Bell,
};

export const EmptyState = ({ 
  icon = 'default',
  title = 'No data yet',
  description,
  actionLabel,
  onAction,
  className 
}) => {
  const Icon = iconMap[icon] || Inbox;
  
  return (
    <div 
      className={cn(
        "flex flex-col items-center justify-center py-16 px-4 text-center",
        className
      )}
      data-testid="empty-state"
    >
      <div className="w-16 h-16 rounded-2xl bg-white/[0.05] flex items-center justify-center mb-6">
        <Icon className="w-8 h-8 text-muted-text" />
      </div>
      
      <h3 className="text-xl font-medium text-cloud-white mb-2">
        {title}
      </h3>
      
      {description && (
        <p className="text-soft-silver text-sm max-w-sm mb-6">
          {description}
        </p>
      )}
      
      {actionLabel && onAction && (
        <Button 
          onClick={onAction}
          className="bg-cloud-white text-obsidian hover:bg-white/90"
          data-testid="empty-state-action"
        >
          {actionLabel}
        </Button>
      )}
    </div>
  );
};

export default EmptyState;
